@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

.portalWrap {
  position: absolute;
  z-index: v.$z-index-tooltip-portal-wrap;

  @include c.containerMedia(v.$tablet-breakpoint) {
    display: none;

    &.enabledOnMobile {
      display: block;
    }
  }
}

.tooltip {
  z-index: v.$z-index-ui-tooltip;
  position: relative;
}
